import axios from "axios";

const PUBLIC_PATH_PREFIXES = [
  "/display/armada",
  "/display/material",
  "/monitoring-display",
  "/job-profile/public",
];

function isPublicPage() {
  const path = window.location.pathname || "";
  return PUBLIC_PATH_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`));
}

function readTokenFromStorage() {
  let t = localStorage.getItem("token") || sessionStorage.getItem("token");
  if (t) return String(t).trim();

  for (const storage of [localStorage, sessionStorage]) {
    try {
      const u = JSON.parse(storage.getItem("user") || "null");
      t = u?.token || u?.accessToken;
      if (t) return String(t).trim();
    } catch {}
  }

  return null;
}

function clearAuthStorage() {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("auth");
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("user");
  sessionStorage.removeItem("auth");
}

if (!window.__PORTAL_AXIOS_AUTH_SETUP__) {
  window.__PORTAL_AXIOS_AUTH_SETUP__ = true;

  axios.interceptors.request.use(
    (config) => {
      const token = readTokenFromStorage();
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const url = String(error?.config?.url || "");
      const isLoginEndpoint = url.includes("/auth/login") || url.endsWith("/login");

      if (status === 401 && !isLoginEndpoint && !isPublicPage()) {
        clearAuthStorage();

        const next = encodeURIComponent(
          `${window.location.pathname}${window.location.search || ""}`
        );

        if (window.location.pathname !== "/login") {
          window.location.href = `/login?expired=1&next=${next}`;
        }
      }

      return Promise.reject(error);
    }
  );
}
